import { useState } from "react";
import LegalDocumentModal from "./LegalDocumentModal";

const LINK_CLASS =
  "cursor-pointer text-[#1B8354] underline underline-offset-2 transition-colors duration-150 hover:text-[#166c44] focus-visible:rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1B8354] motion-reduce:transition-none dark:text-emerald-400";

/**
 * Opens the Terms & Conditions or Privacy Policy in a popup instead of leaving the page.
 * It is a button (never submits the surrounding form) and stops the click so a wrapping checkbox label
 * doesn't toggle. `onAgree` adds the popup's "I agree" button; `className` replaces the default link look.
 */
export default function LegalLink({ type, onAgree, className = LINK_CLASS, children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`inline border-0 bg-transparent p-0 text-start font-[inherit] ${className}`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen(true);
        }}
      >
        {children}
      </button>
      <LegalDocumentModal type={type} open={open} onClose={() => setOpen(false)} onAgree={onAgree} />
    </>
  );
}
